module.exports = __webpack_public_path__ + "img/info-04.a3fce412.png";